import { useState } from "react";
import useWexClient from "./Clients/wexClient,";

const useUser = () => {
  const {
    createUser,
    createUserMaster,
    updateUserNameFetch,
    updatePasswordFetch,
    countAgentByStatus,
    getAllConnectAgents,
    forgotPassword,
    verifyCode
  } = useWexClient();
  const [loader, setLoader] = useState(false);

  const createNewUser = async (body = {}) => {
    setLoader(true);
    try {
      const response = await createUser(body);
      setLoader(false);
      return response;
    } catch (err) {
      setLoader(false);
      throw (err);
    }
  };

  const createNewUserMaster = async (body = {}) => {
    setLoader(true);
    try {
      const response = await createUserMaster(body);
      setLoader(false);
      return response;
    } catch (err) {
      setLoader(false);
      throw (err);
    }
  };

  const updateUserName = async (body = {}) => {
    try {
      const response = await updateUserNameFetch(body);
      setLoader(false);
      return response;
    } catch (err) {
      setLoader(false);
      throw (err);
    }
  };

  const updatePasswordUser = async (body = {}) => {
    try {
      const response = await updatePasswordFetch(body);
      setLoader(false);
      return response;
    } catch (err) {
      setLoader(false);
      throw (err);
    }
  };

  const forgotPasswordUser = async (idUser) => {
    setLoader(true);
    try {
      const response = await forgotPassword(idUser);
      setLoader(false);
      return response;
    } catch (err) {
      setLoader(false);
      throw (err);
    }
  };

  const verifyCodeUser = async (user, code) => {
    setLoader(true);
    try {
      const response = await verifyCode(user, code);
      setLoader(false);
      return response;
    } catch (err) {
      setLoader(false);
      throw (err);
    }
  };

  const countUserByStatus = async (body) => {
    try {
      const response = await countAgentByStatus(body);
      setLoader(false);
      return response;
    } catch (err) {
      setLoader(false);
      throw (err);
    }
  };

  const countAllAgents = async (body) => {
    try {
      const response = await getAllConnectAgents(body);
      setLoader(false);
      return response;
    } catch (err) {
      setLoader(false);
      throw (err);
    }
  };

  return {
    createNewUser,
    createNewUserMaster,
    updateUserName,
    updatePasswordUser,
    forgotPasswordUser,
    verifyCodeUser,
    countUserByStatus,
    countAllAgents,
    loader
  };
};

export default useUser;
